import { useLanguage } from "../../context/LanguageContext";
import DynamicForm from "../../components/DynamicForm/DynamicForm";
import formConfig from "../../config/formConfig";
import styles from "./FormPage.module.css";
import { getFormPageSchema } from "../../utils/validationSchema";

export default function FormPage() {
    const { t } = useLanguage();

  const handleSubmit = (data: Record<string, unknown>) => {
    console.log("Form data:", data);
  };

  return (
    <div className={styles.container}>
      <DynamicForm
        config={formConfig}
        validationSchema={getFormPageSchema(t)}  
        onSubmit={handleSubmit}
        showDataAlert={true}
        showToast={true}
        requireDirty={true}
      />
    </div>
  );
}
